module.exports = __webpack_public_path__ + "img/IMG_20240715_192016.5c72e76c.jpg";